export const QUEUE_COLORS = [
  "#783BFF",
  "#2563eb",
  "#0891b2",
  "#059669",
  "#d97706",
  "#dc2626",
  "#7c3aed",
  "#db2777",
];

export function dlqToColor(visible) {
  if (!visible || visible <= 0) {
    return { bg: "#f8fafc", border: "#cbd5e1", text: "#64748b" };
  }
  return { bg: "#fef3c7", border: "#d97706", text: "#92400e" };
}

export function sqsToColor(peak, maxPeak) {
  return peakToColorWithHue(peak, maxPeak, 210);
}

export function lambdaToColor(peak, maxPeak) {
  return peakToColorWithHue(peak, maxPeak, 275);
}

function peakToColorWithHue(peak, maxPeak, hue) {
  if (!peak || peak <= 0) {
    return { bg: "#f3f4f6", border: "#d1d5db", text: "#6b7280" };
  }
  const ratio = maxPeak > 0 ? Math.min(peak / maxPeak, 1) : 0;
  const lightness = 95 - ratio * 45;
  const saturation = 40 + ratio * 50;
  return {
    bg: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    border: `hsl(${hue}, ${saturation + 10}%, ${lightness - 20}%)`,
    text: ratio > 0.5 ? "#ffffff" : hue > 240 ? "#3b0764" : "#1e3a5f",
  };
}

export function peakToColor(peak, maxPeak) {
  return sqsToColor(peak, maxPeak);
}
